import {
  Avatar,
  type AvatarSize,
  type AvatarViewingContext,
} from '@procurify/ui'

import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { useUserAvatarViewingContext } from './useUserAvatarViewingContext'

export interface IUserAvatarProps {
  url?: string
  name: string
  userId?: number
  viewingContext?: AvatarViewingContext
  shadow?: boolean
  size?: AvatarSize
}

export const UserAvatar = ({
  url,
  name,
  userId,
  viewingContext,
  size,
  shadow,
}: IUserAvatarProps) => {
  const formatMedia = useFormatMedia()

  const photoUrl = url ? formatMedia(url) : undefined

  const resolvedViewingContext = useUserAvatarViewingContext(
    userId,
    viewingContext
  )

  return (
    <Avatar
      photoUrl={photoUrl}
      name={name}
      viewingContext={resolvedViewingContext}
      size={size}
      shadow={shadow}
    />
  )
}

UserAvatar.displayName = 'UserAvatar'
